// Blishcrown Logo Components
const LOGO_URL = 'https://customer-assets.emergentagent.com/job_blishcrown-gatefix/artifacts/rebdvq7x_BlishCrown%20Logo.jpeg';

export const LogoPrimary = ({ size = 'md' }) => {
  const sizes = {
    sm: { img: 'h-8', text: 'text-base' },
    md: { img: 'h-12', text: 'text-2xl' },
    lg: { img: 'h-16', text: 'text-4xl' }
  };
  
  const s = sizes[size];
  
  return (
    <div className="flex items-center gap-2">
      <img 
        src={LOGO_URL}
        alt="Blishcrown"
        className={`${s.img} w-auto object-contain`}
        style={{filter: 'drop-shadow(0 0 10px rgba(255, 215, 0, 0.6))'}}
      />
    </div>
  );
};

export const LogoMonogram = ({ size = 'md', variant = 'default' }) => {
  const sizes = {
    sm: 'h-8',
    md: 'h-12',
    lg: 'h-16'
  };
  
  return (
    <img 
      src={LOGO_URL}
      alt="Blishcrown"
      className={`${sizes[size]} w-auto object-contain`}
      style={{filter: variant === 'default' ? 'drop-shadow(0 0 20px rgba(255, 215, 0, 0.4))' : 'drop-shadow(0 0 15px rgba(30, 242, 255, 0.4))'}}
    />
  );
};

export const LogoIcon = ({ size = 'md' }) => {
  const sizes = {
    sm: 'h-6',
    md: 'h-10',
    lg: 'h-16'
  };
  
  return (
    <img 
      src={LOGO_URL}
      alt="Blishcrown"
      className={`${sizes[size]} w-auto object-contain`}
      style={{filter: 'drop-shadow(0 0 15px rgba(255, 215, 0, 0.8))'}}
    />
  );
};